import Swal from 'sweetalert2'
import { ServiceCids } from '@/service/cid/serviceCids'

export default {
  namespaced: true,
  state: {
    CidList: [],
  },
  getters: {
    getCidList: state => state.CidList,
  },
  mutations: {
    SetCidsList(state, CidList) {
      state.CidList = CidList
    },
  },
  actions: {
    async fetchCidList({ commit }) {
      try {
        const cidList = await ServiceCids.cidsAll()
        commit('SetCidList', cidList)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao buscar CIDs',
          text: 'Ocorreu um erro ao buscar os CIDs. Tente novamente mais tarde.',
        })
      }
    },
  },
}
